var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnDLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260.795,
    height: 41.843,
    viewBox: "0 0 260.795 41.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36484",
    "data-name": "Group 36484",
    transform: "translate(-61.999 -35.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M274.437,30.53,273.2,35.1l-2.176-4.572h-4.265l-3.341,12.441h4.8l1.3-4.8,2.291,4.8H275.9l3.341-12.441Z",
    transform: "translate(-48.821 22.429)",
    fill: "#bccdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M367.845,20.182,371.162,44.8h8.4L393.489,24.04,387.915,44.8h21.231l2-7.541H398.774l.381-1.379h12.259l1.8-6.776H400.965l.324-1.212H413.5l2.041-7.542H385.812l-7.294,11.846L377.6,20.182Z",
    transform: "translate(-92.751 26.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M331.561,20.182h-8.52l-8.764,12.766a13.909,13.909,0,0,0,.188-2.2,9.813,9.813,0,0,0-2.7-7.23c-2.1-2.1-5.3-3.165-9.527-3.165h-8.7L286.977,44.8h10.869a19.2,19.2,0,0,0,9.928-2.38L306.14,44.8h9.893l1.995-3.129h7.452L325.8,44.8h9.462ZM303.863,35.1a6.962,6.962,0,0,1-5.118,1.762H298.1l2.289-8.568h.889c1.93,0,2.749.425,3.387,1.063a3,3,0,0,1,.73,2.223,5.056,5.056,0,0,1-1.529,3.52m16.748,2.4,3.673-5.813.65,5.813Z",
    transform: "translate(-58.73 26.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M246.152,24.078l-.324-.4c-1.6-1.962-5.469-4.073-10.2-4.073a16.581,16.581,0,0,0-11.89,4.528,13.781,13.781,0,0,0-4.063,9.96c0,5.056,3.166,10.96,12.092,10.96a18.864,18.864,0,0,0,9.247-2.477l.2-.117,3.307-12.836h-3.768ZM234.618,35.77l-.454,1.481a4.9,4.9,0,0,1-1.563.23c-1.911,0-3.951-.985-3.951-3.751a5.933,5.933,0,0,1,1.729-4.42,6.534,6.534,0,0,1,4.752-1.8,7.544,7.544,0,0,1,5,1.944l.18.166h-7.926L230.83,35.77Z",
    transform: "translate(-30.417 27.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M153.553,19.941,147.871,41.1l-3.18-21.156H136.17L121.688,41.035,119.882,36.4a10.537,10.537,0,0,0,3.87-2.361,8.283,8.283,0,0,0,2.432-6.165,7.153,7.153,0,0,0-2-5.266c-1.769-1.768-4.795-2.665-8.995-2.665h-9.528l-5.207,19.346L94.18,34.328l-.359.432a5.114,5.114,0,0,1-4.084,2.222c-1.9,0-3.085-1.309-3.085-3.418a6.309,6.309,0,0,1,1.762-4.386,4.749,4.749,0,0,1,3.421-1.429,2.945,2.945,0,0,1,3.071,2.4l.171.649,8.016-3.49-.114-.47c-1.079-4.459-4.954-7.23-10.112-7.23a15.205,15.205,0,0,0-11.124,4.3,14.611,14.611,0,0,0-4.4,10.359c0,6.456,4.672,10.794,11.626,10.794a13.379,13.379,0,0,0,11.14-5.316l.342-.444-1.413,5.261h8.98l1.852-6.823h1.1l2.541,6.823h15.653l1.995-3.129h7.452l.318,3.129h16.993l6.611-24.616Zm-37.726,11.4a5.415,5.415,0,0,1-2.886.651H111.36l1.621-5.944h1.909a2.259,2.259,0,0,1,2.5,1.978,3.57,3.57,0,0,1-1.559,3.314m17.956,5.908,3.673-5.813.65,5.813Z",
    transform: "translate(29.461 27.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M17.391,38.876.712,8.465A5.717,5.717,0,0,1,5.724,0H39.082a5.716,5.716,0,0,1,5.012,8.465L27.415,38.876a5.717,5.717,0,0,1-10.024,0",
    transform: "translate(62 35.272)",
    fill: "#bbf41e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M33.47,12.694V11.287a1.685,1.685,0,1,0-3.37,0v1.407a9.486,9.486,0,1,0,3.37,0M31.785,28.136A6.112,6.112,0,0,1,30.1,16.148V19.7a1.685,1.685,0,1,0,3.37,0v-3.55a6.112,6.112,0,0,1-1.685,11.989",
    transform: "translate(52.619 31.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 260.793,
    height: 41.843,
    transform: "translate(62 35.272)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnDLogoDark);
export default __webpack_public_path__ + "static/media/CnD_Logo_Dark.1346ab156ef5b3b1368de3e9b220ea62.svg";
export { ForwardRef as ReactComponent };